import Vue from 'vue'
// import SvgIcon from '@/components/SvgIcon'// svg组件
import SvgIcon from '@/components/FontAwesomeIcon'// svg组件
import 'font-awesome/css/font-awesome.min.css'

// register globally
Vue.component('svg-icon', SvgIcon)

// const req = require.context('./svg', false, /\.svg$/)
// const requireAll = requireContext => requireContext.keys().map(requireContext)
// requireAll(req)



// WEBPACK FOOTER //
// ./src/icons/index.js